import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ref, onValue, update, get } from "firebase/database"; // Thêm update và get
import { db } from "../../assets/firebase/firebaseconfig";
import "./styles.css";
import { Helmet } from "react-helmet-async";
import { createSlug } from "../../assets/js/slug";

const News = () => {
  const [newsData, setNewsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("Mới nhất");
  const [visibleCount, setVisibleCount] = useState(15);

  const categories = ["Mới nhất", "Tin công ty", "Kiến thức chuyên ngành", "Công nghệ mới", "Sự kiện"];

  // 1. Lấy dữ liệu và TỰ ĐỘNG UPDATE SLUG nếu thiếu
  useEffect(() => {
    const newsRef = ref(db, "news");
    
    const unsubscribe = onValue(newsRef, async (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const updates = {};
        let hasMissingSlug = false;

        const list = Object.keys(data).map((key) => {
          // KIỂM TRA: Nếu bài viết chưa có slug, tạo slug và đánh dấu để update
          if (!data[key].slug) {
            const newSlug = createSlug(data[key].title);
            updates[`/news/${key}/slug`] = newSlug;
            hasMissingSlug = true;
          }
          
          return {
            id: key,
            ...data[key],
          };
        });

        // Nếu có bài thiếu slug, thực hiện update lên Firebase ngay lập tức
        if (hasMissingSlug) {
          await update(ref(db), updates);
          console.log("✅ Đã tự động cập nhật Slug cho các bài viết thiếu!");
        }

        setNewsData(list.sort((a, b) => b.createdAt - a.createdAt));
      } else {
        setNewsData([]);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const filteredNews = newsData.filter(
    (news) => activeTab === "Mới nhất" || news.category === activeTab
  );

  if (loading) return <div style={{ padding: "10rem", textAlign: "center" }}>Đang tải tin tức...</div>;

  return (
    <div className="baomoi-wrapper">
      <Helmet>
        <title>Tin Tức Ngành Cơ Điện & Kỹ Thuật M&E | Habako M&E</title>
        <meta name="description" content="Cập nhật tin tức thị trường cơ điện, hướng dẫn kỹ thuật..." />
      </Helmet>

      <nav className="baomoi-sub-nav">
        <div className="container scroll-nav">
          {categories.map((cat) => (
            <button
              key={cat}
              className={activeTab === cat ? "active" : ""}
              onClick={() => { setActiveTab(cat); setVisibleCount(15); }}
            >
              {cat}
            </button>
          ))}
        </div>
      </nav>

      <div className="container baomoi-layout">
        <main className="baomoi-main">
          {filteredNews.length ? (
            filteredNews.slice(0, visibleCount).map((news) => (
              <div key={news.id} className="baomoi-item">
                {/* Dùng news.slug (lúc này chắc chắn đã có nhờ logic update ở trên) */}
                <Link to={`/tin-tuc/${news.slug || createSlug(news.title)}`} className="baomoi-link">
                  <div className="baomoi-thumb">
                    <img src={news.image} alt={news.title} />
                  </div>
                  <div className="baomoi-content">
                    <h3 className="baomoi-title">{news.title}</h3>
                    <p className="baomoi-sapo">{news.summary || news.sapo}</p>
                    <div className="baomoi-meta">
                      <span className="source">{news.author || "Habako News"}</span>
                      <span className="dot">•</span>
                      <span className="time">
                        {new Date(news.createdAt).toLocaleDateString("vi-VN")}
                      </span>
                    </div>
                  </div>
                </Link>
              </div>
            ))
          ) : (
            <p style={{ padding: "1rem" }}>Hiện không có bài viết nào liên quan</p>
          )}

          {visibleCount < filteredNews.length && (
            <button className="baomoi-load-more" onClick={() => setVisibleCount((v) => v + 15)}>
              Xem thêm
            </button>
          )}
        </main>

        <aside className="baomoi-sidebar">
          <div className="sidebar-section">
            <h4 className="sidebar-heading">TIN NÓNG</h4>
            {newsData.slice(0, 5).map((item, idx) => (
              <Link to={`/tin-tuc/${item.slug || createSlug(item.title)}`} key={item.id} className="hot-item">
                <span className={`rank rank-${idx + 1}`}>{idx + 1}</span>
                <p>{item.title}</p>
              </Link>
            ))}
          </div>
        </aside>
      </div>
    </div>
  );
};

export default News;